<script>
import { list46Item } from '../../../api/46';
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
export default {
  components: {},
  data() {
    return {
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
      },
      en,
      zh,
      zt:[],
      loading: false,
      pageNo: 1,
      limit: 10,
      total: 0,
      formLabelWidth: '120px',
      updateFormVisible: false,
      search:''
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {

    this.loading = true
  },
  mounted() {
    this.ListC()
  },
  methods: {
    translate() {
      locale.use(this[this.lang])
      this.zt = [this.$t('report46.unaudited'), this.$t('report46.audited')]
      this.list = this.list.map((i)=>{
        i.zt = this.zt[i.checked]
        return i
      })
    },
    async ListC(pager = 1) {
      this.pageNo = pager
      const formdata = new FormData()
      formdata.append('search', this.search)
      // formdata.append('applicantTimeStart', select.applicantTimeStart)
      // formdata.append('applicantTimeEnd', select.applicantTimeEnd)
      // formdata.append('state', select.state)
      const result = await list46Item(this.pageNo, this.limit,formdata)
      console.log(result);
      if (result.code == 0) {
        this.total = result.data.total
        this.list = result.data.records.map((i)=>{
          i.zt = this.zt[i.checked]
        return i
        })
        console.log(this.list);
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },

    async handleRefresh() {
      await this.ListC()

    },
    routeTo(row){
    console.log(row);
    this.$router.push({ path:'/46reportDetail',
		query: { id: row.id,checked:row.checked }
	})
    },
    aa(){
      this.ListC()
    }
  }
}

  ;
</script>
<template>
  <div>
    <div style="width: 100%; height: 100%">
      <div class="equipmentList">
        <div class="container">
          <div>
            <span>{{ $t('report46.title') }}</span>
          </div>

          <div>
            <el-input v-model="search" @change="aa"></el-input>
          </div>
        </div>
        <el-table
          :data="list"
          border
        >
          <el-table-column
            prop="customerName"
            :label="$t('customer.company')"
            width="250"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            :label="$t('customer.address')"
            width="300"
          >
          </el-table-column>
          <el-table-column
            prop="linkMan"
            :label="$t('orders.contactPerson')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="linkPhone"
            :label="$t('device.mobile')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="machineModel"
            :label="$t('common.model')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="machineNumber"
            :label="$t('device.code')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="serverMan"
            :label="$t('binding.serviceMan')"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="zt"
            :label="$t('report46.auditState')"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="completeChecked"
            :label="$t('report46.progress')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="complete"
            :label="$t('report46.completeState')"
            width="110"
          >
          </el-table-column>

          <el-table-column
            :label="$t('common.operation')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="text"

                @click="routeTo(scope.row)"
              >{{ $t('warning.check') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :key="lang"
          @size-change="ListC"
          @current-change="ListC"
          :pager-count="9"
          v-model:current-page="pageNo"
          v-model:page-size="limit"
          :page-sizes="[10, 20, 30, 40]"
          :background="true"
          layout="prev, pager, next, jumper,->, sizes,total"
          :total="total"
        />
      </div>

    </div>
  </div>
</template>


<style lang="less" scoped>
.row {
  margin-top: 5px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.equipmentList {
  padding: 15px;
  width: 100%;
  height: 100%;
}

.equipmentList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
</style>
